import { InternalIconName } from "../ts-types";

import * as registerIcons from "../icons";

export class RowSeriesNumberHelper {
    constructor(_table) {
        this._table = _table;
        const regedIcons = registerIcons.get();
        this.dragReorderIconName = regedIcons[InternalIconName.dragReorderIconName];
    }
    getIcons(col, row) {
        return [ this.dragReorderIconName ];
    }
}
//# sourceMappingURL=row-series-number-helper.js.map